import clsx from 'clsx'

import { SectionHeadingProps } from './ts'

function SectionHeading({ className, text }: SectionHeadingProps) {
  return (
    <h2 className={clsx('font-medium text-lg md:text-2xl', className)}>
      {text}
    </h2>
  )
}

export default SectionHeading
